import type {PayloadAction} from '@reduxjs/toolkit'
import type {SagaIterator} from 'redux-saga'
import {takeLatest, put, call} from 'redux-saga/effects'
import {standardErrorAction} from 'helpers/saga'
import {updateEntity} from 'store/entity/asyncHelpers'
import type {Organization} from 'types/organization'
import type {EntityUpdateParams} from '../../types'
import {updateOrganizationSuccess} from '../actions'
import {UPDATE, UPDATE_FAILURE} from '../constants'

export function* updateOrganization(
  action: PayloadAction<EntityUpdateParams<Organization>>
): SagaIterator<Organization> {
  try {
    const payload = yield call(() =>
      updateEntity({
        kind: 'ORGANIZATION',
        id: action.payload.id,
        data: action.payload,
      })
    )
    yield put(updateOrganizationSuccess(payload))
    return payload
  } catch (e: any) {
    yield put(standardErrorAction(UPDATE_FAILURE, e))
    throw e
  }
}

export function* updateSaga() {
  yield takeLatest(UPDATE, updateOrganization)
}
